// Local drafts of long forms (Ordre 24-4, CDC V1 § 14 « reprise de saisie »). A draft lives in THIS browser only, per account and per form, for a
// few days; it holds plain fields (never a file, never a secret) and is never presented as something the server has: the banner says so.
// Storage may be missing or full (private window): every call is guarded and the form works the same without it.

export const DRAFT_TTL_MS = 7 * 24 * 60 * 60 * 1000;
export const DRAFT_PREFIX = "jamora.draft:";

export function draftKey(userId, name) {
  return `${DRAFT_PREFIX}${userId || "anonymous"}:${name}`;
}

const store = () => {
  try {
    return globalThis.localStorage || null;
  } catch (e) {
    return null;
  }
};

// {values, savedAt} or null (absent, unreadable, expired — an expired one is removed on the way).
export function readDraft(key, now = Date.now(), storage = store()) {
  try {
    const raw = storage?.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || !parsed.values || typeof parsed.values !== "object" || Array.isArray(parsed.values)) return null;
    if (typeof parsed.savedAt !== "number" || now - parsed.savedAt > DRAFT_TTL_MS) {
      storage.removeItem(key);
      return null;
    }
    return parsed;
  } catch (e) {
    return null;
  }
}

export function writeDraft(key, values, now = Date.now(), storage = store()) {
  try {
    storage?.setItem(key, JSON.stringify({ values, savedAt: now }));
    return true;
  } catch (e) {
    return false;
  }
}

export function removeDraft(key, storage = store()) {
  try {
    storage?.removeItem(key);
  } catch (e) {
    /* nothing to remove */
  }
}

// Only the fields a person typed: functions and Files are dropped, and a draft identical to the empty form is not worth keeping.
export function plainValues(values) {
  return JSON.parse(JSON.stringify(values ?? {}));
}

export function differsFrom(baseline, values) {
  return JSON.stringify(plainValues(baseline)) !== JSON.stringify(plainValues(values));
}

// Seven days later every draft is gone; this removes those already expired for one account (called when a form opens).
export function purgeExpired(userId, now = Date.now(), storage = store()) {
  try {
    const prefix = `${DRAFT_PREFIX}${userId || "anonymous"}:`;
    for (let i = (storage?.length || 0) - 1; i >= 0; i -= 1) {
      const key = storage.key(i);
      if (key && key.startsWith(prefix)) readDraft(key, now, storage);
    }
  } catch (e) {
    /* nothing to purge */
  }
}
